import React from "react";
import { GuardianProvider } from "./GuardianProvider";
import GuardianSurface from "./GuardianSurface";

/**
 * The shell owns this host. `sessionKey` changes only with the authenticated
 * user/tenant.
 *
 * `enabled` gates the surface rather than the host, so the shell can render
 * this unconditionally: swapping between `<GuardianHost>{children}</…>` and a
 * bare `{children}` changes the element type at that position, which remounts
 * the whole authenticated shell -- including the routed `<Outlet />` -- every
 * time the flag resolves or a session changes.
 */
const GuardianHost: React.FC<{
  children: React.ReactNode;
  sessionKey?: string;
  enabled?: boolean;
}> = ({ children, sessionKey, enabled = true }) =>
  enabled ? (
    <GuardianProvider sessionKey={sessionKey}>
      {children}
      <GuardianSurface />
    </GuardianProvider>
  ) : (
    <>{children}</>
  );
export default GuardianHost;
